<template>
  <div
    class="trending-card"
    :class="`${createRenderType}-trending-card`"
    ref="refTrendingCard"
  >
    <AudioPlayer
      ref="refPlayer"
      :url="`${getObjectStorageFullUrl(data?.song?.mp3_url)}`"
      :duration="renderData.duration"
      @syncDuration="syncDuration"
      @syncPlayState="syncPlayState"
      @syncLoadingState="syncLoadingState"
      @syncProgress="syncProgress"
      @curPlayEnded="onCurPlayEnded"
    >
      <div
        class="cover-img pointer"
        :class="{
          'isplay-true': renderData.isplay,
          'isplay-false': !renderData.isplay,
          'isplay-pause-show': !renderData.isplay && renderData.isCurPlay,
        }"
        @click="doTogglePlay"
      >
        <LazyLoadImg
          :src="
            data?.song?.cover
              ? getObjectStorageFullUrl(data?.song?.cover)
              : defaultCover
          "
        ></LazyLoadImg>
        <div class="cover-img-tags flex-row-center">
          <template
            v-for="(item, index) in [
              ...new Set(data?.song?.control_types || []),
            ]"
          >
            <div
              :key="index"
              v-if="constRefer.referI18nCodeMap[item] && item != 4"
              class="cover-img-tags-item"
              @click.stop="
                () => {
                  goCreatePage(item);
                }
              "
            >
              {{ $$t(constRefer.referI18nCodeMap[item]) }}
            </div>
          </template>
        </div>
        <div class="play-num-box flex" v-if="data?.play_count">
          <div class="play-num flex-row-center">
            <img src="@/assets/img/store/listen.png" alt="" />
            <div class="num">
              {{ formatNumberRound(data?.play_count) }}
            </div>
          </div>
          <div class="play-num play-drration flex-row-center">
            <img src="@/assets/img/store/duration.png" alt="" />
            <div class="num">
              {{
                mediaUtil.formatTime(data?.song?.duration_milliseconds / 1000)
              }}
            </div>
          </div>
        </div>
        <div class="cover-img-op">
          <div class="cover-img-op-items">
            <div
              v-if="createRenderType == 'pc'"
              class="cover-img-op-item like flex-center"
              @click.stop="changeFavorite(data.is_liked)"
            >
              <img
                v-if="!data.is_liked"
                src="@/assets/img/praise-ico-white.png"
                alt=""
              />
              <img v-else src="@/assets/img/praise-high-ico-white.png" alt="" />
            </div>
            <div
              @click.stop="handleShare"
              v-if="createRenderType == 'pc'"
              class="cover-img-op-item share flex-center"
            >
              <img src="@/assets/img/share-ico.png" alt="" />
            </div>
            <div class="cover-img-op-item play-op pointer flex-center">
              <i class="flex-center"></i>
              <div class="playing">
                <LoaderWave :animation="renderData.isplay"></LoaderWave>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row-center">
        <div class="song-name olh pointer" @click="handleDetail">
          {{ data?.song?.title }}
        </div>
        <div
          v-if="data?.model"
          :class="{
            'flex-center': true,
            'cover-version': true,
            [`${data?.model?.split(' ').pop()}`]: true,
          }"
        >
          {{ data?.model }}
        </div>
      </div>
      <div class="tag olh">
        {{
          data?.song?.description
            ? data.song.description.trim()
            : combineStrings(data?.song?.genres, data?.song?.moods)
        }}
      </div>
      <div class="singer flex-row-center">
        <img
          :src="`${getObjectStorageFullUrl(data?.user?.profile_image)}`"
          alt=""
        />
        <div class="name olh">{{ data?.user?.stage_name }}</div>
      </div>
    </AudioPlayer>
  </div>
</template>

<script setup>
import { defineProps, watch, reactive, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import useDiscoverStore from "@/store/discover/discoverDataStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import constRefer from "@/config/referConst.js";
import constTags from "@/config/const.js";
import { formatNumberRound } from "@/utils/tools";
import mediaUtil from "@/components/media/utils/utils.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue";
import LoaderWave from "@/components/animation/LoaderWave.vue";
import LazyLoadImg from "@/components/media/lazyLoad/LazyLoadImg.vue";
import defaultCover from "/assets/default-cover-3x.png";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t, $$language } = globalProperties?.$i18n;
const router = useRouter();
const discoverDataStore = useDiscoverStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits([
  "togglePlay",
  "changeFavorite",
  "onCurPlayEnded",
  "handleShare",
]);
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const refPlayer = ref(null);
const renderData = reactive({
  duration: (props.data?.song?.duration_milliseconds ?? 0) / 1000,
  isplay: false,
  buffer: false,
  progress: 0,
  isCurPlay: false,
});

watch(
  () => props.data,
  () => {
    renderData.duration = props.data?.song?.duration_milliseconds / 1000;
  }
);

const syncDuration = (duration) => {
  renderData.duration = duration;
};

const syncPlayState = (playState) => {
  console.log("syncPlayState🍎🍎🍎", playState);
  renderData.isplay = playState;
};

const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
};

const syncProgress = (progress) => {
  renderData.progress = progress;
};

const doTogglePlay = () => {
  emits("togglePlay");
  refPlayer.value?.changeOp().then((isPlayed) => {
    if (isPlayed) {
      discoverDataStore.doPlayStateReport(props.data, 1);
    }
  });
};

const goCreatePage = (item) => {
  createLayoutStore.toggleCreateEditOpenState(true);
  createLayoutStore.setCurHighlightReferType({
    type: constRefer.referCodeKeyMap[item],
  });
  createLayoutStore.setCreateEditMode("hard");
  globalProperties.logClickEvent("home_single_song_feature", {
    feature: constRefer.referPonitCodeKeyMap[item],
    content_id: props.data?.song?.song_id,
  });
  router.push({
    name: "create",
  });
};

const onCurPlayEnded = () => {
  emits("onCurPlayEnded");
};

// 分享复制链接
const handleShare = () => {
  emits("handleShare");
};

const changeFavorite = (is_liked) => {
  emits("changeFavorite", is_liked);
};

const handleDetail = () => {
  globalProperties.logClickEvent("home_single_song_title", {
    content_id: props.data?.song?.song_id,
  });
  refPlayer.value.changeOp(true).then((isPlayed) => {
    emits("togglePlay");
  });
  router.push({
    name: "songDetail",
    query: {
      form: "home",
    },
    params: {
      song_id: props.data?.song?.song_id,
    },
  });
};

const combineStrings = (str1, str2) => {
  // str1 =>genres str2 => moods
  const genres = constTags.getRenderLabel(str1, constTags.StyleLabelData.map,$$language());
  const moods = constTags.getRenderLabel(
    str2,
    constTags.EmotionalLabelData.map,
    $$language()
  );
  if (genres?.length && moods?.length) {
    return `${genres.join(" ")} | ${moods.join(" ")}`;
  } else if (genres?.length) {
    return genres.join(" ");
  } else if (moods?.length) {
    return moods.join(" ");
  } else {
    return "";
  }
};
</script>

<style lang="scss">
.trending-card {
  .more {
    width: 32px;
    height: 32px;
    .more-popup {
      &-top {
        bottom: 30px;
        right: 0px;
        padding: 0px 0 36px;
      }
      &-bottom {
        right: 0px;
        top: 4px;
        padding: 36px 0 0;
      }
    }
  }
}
</style>
<style lang="scss">
.trending-card {
  width: 220px;
  margin-right: 20px;
  &:last-of-type {
    margin: 0;
  }
  .cover-img {
    position: relative;
    width: 220px;
    height: 220px;
    border-radius: 16px;
    overflow: hidden;
    > img {
      border-radius: 16px;
      width: 220px;
      height: 220px;
      transition: transform 0.3s ease-in-out;
      transform-origin: center;
    }
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 默认阴影 */
    &:hover {
      > img {
        transform: scale(1.075);
      }
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15); /* 悬浮时阴影加深 */
      .play-num-box {
        display: none;
      }
    }
    .play-num-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      box-sizing: border-box;
      padding-bottom: 10px;
      height: 100px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.6) 100%
      );
      .play-num {
        opacity: 0.8;
        margin-left: 12px;
        align-items: flex-end;
        img {
          width: 16px;
          height: 16px;
          display: block;
        }
        .num {
          margin-top: 2px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          margin-left: 4px;
        }
      }
    }
    .cover-img-op {
      position: absolute;
      bottom: 12px;
      left: 0;
      right: 0;
      display: none;
    }
    .cover-img-op-items {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      // justify-content: space-between;
    }

    .cover-img-tags {
      position: absolute;
      top: 8px;
      left: 8px;
      flex-wrap: wrap;
      .cover-img-tags-item {
        border-radius: 4px;
        padding: 0 6px;
        background: linear-gradient(
          45deg,
          rgba(0, 0, 0, 0.5),
          rgba(0, 0, 0, 0.1)
        );
        backdrop-filter: blur(5px);
        font-family: HarmonyOS Sans SC;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        color: #ffffff;
        display: inline-block;
        vertical-align: middle;
        margin: 0 4px 4px 0;
        cursor: pointer;
        &:last-child {
          margin: 0 0 4px 0;
        }
        &:hover {
          background: linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.75),
            rgba(0, 0, 0, 0.1)
          );
        }
      }
    }
    .duration {
      position: absolute;
      bottom: 8px;
      left: 8px;
      padding: 6px 9px;
      background: rgba(0, 0, 0, 0.2);
      backdrop-filter: blur(10px);
      font-size: 14px;
      border-radius: 8px;
    }
    .cover-img-op-item {
      width: 48px;
      height: 48px;
      min-width: 42px;
      min-height: 42px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.2);
      backdrop-filter: blur(12px);
      img,
      i {
        width: 24px;
        height: 24px;
        // opacity: 0.5;
      }
      &.play-op {
        // margin-right:10px;
        i {
          display: block;
          background: url(@/assets/img/content/pc-hover-play.png);
          background-size: 100% 100%;
        }
      }
      .playing {
        height: 16px;
        width: 16px;
        display: none;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.5);
        img,
        i {
          opacity: 1;
          opacity: 1;
        }
      }
    }
    &.isplay-false:hover {
      .cover-img-op {
        display: block;
      }
    }
    &.isplay-true {
      .cover-img-op {
        display: block;
      }
      .cover-img-op-items {
        justify-content: end;
      }
      .like,
      .share {
        display: none;
      }
      .play-op {
        margin-right: 10px;
        .playing {
          display: block;
        }
        i {
          display: none;
        }
        &:hover {
          .playing {
            display: none;
          }
          i {
            display: block;
            background: url(@/assets/img/content/pc-hover-pause.png);
            background-size: 100% 100%;
          }
        }
      }

      &:hover {
        .cover-img-op {
          display: block;
        }
        .like,
        .share {
          display: flex;
        }
        .cover-img-op-items {
          justify-content: space-evenly;
        }
        .play-op {
          margin-right: 0px;
        }
      }
    }
  }
  .song-name {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
    height: 28px;
    &:hover {
      color: #94adff;
    }
    .more-img {
      width: 24px;
      height: 24px;
      margin-left: 6px;
    }
  }
  .cover-version {
    flex-shrink: 0;
    margin: 8px 0 0 6px;
    height: 14px;
    border-radius: 4px;
    padding: 0px 3px;
    box-sizing: border-box;
    border: 1px solid rgba(148, 173, 255, 0.5);
    backdrop-filter: blur(12px);
    font-family: HarmonyOS Sans SC;
    font-size: 10px;
    font-weight: normal;
    line-height: 12px;
    letter-spacing: 0em;
    color: #94adff;
    min-width: -moz-max-content;
    min-width: max-content;
    &.O1,&.O2,&.O3,&.O4,&.O5 {
      color: #fcff35;
      background: rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(255, 241, 114, 0.5);
    }
  }
  .tag {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    // height: 20px;
    opacity: 0.5;
    text-transform: capitalize;
  }
  .singer {
    margin-top: 8px;
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
    .name {
      margin-left: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      opacity: 0.5;
    }
  }
}

.mobile-trending-card {
  width: 160px;
  .cover-img {
    width: 160px;
    height: 160px;
    .play-num-box {
      width: 100%;
      height: 60px;
      .play-drration {
        margin-top: 6px;
        margin-left: 8px;
      }
      .play-num {
        img {
          width: 12px;
          height: 12px;
        }
        .num {
          margin-left: 2px;
          font-size: 10px;
        }
      }
    }
    img {
      width: 160px;
      height: 160px;
    }
    .cover-img-op {
      left: 12px;
      right: 12px;
      display: block;
    }
    .cover-img-op-item {
      width: 42px;
      height: 42px;
    }
    .cover-img-op-items {
      justify-content: end !important;
    }

    .cover-img-op-item.play-op i {
      height: 22px;
      width: 22px;
    }
    .play-op {
      visibility: visible;
      i {
        opacity: 1;
      }
    }
  }
}
</style>
